import { Button } from '@/components/ui/button'
import { useFilters } from '@/hooks/useFilters'
import { listAutomationsQuery } from '@/queries/automation.query'
import { IconPlus, IconRefresh } from '@tabler/icons-react'
import { useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { useAutomations } from '../context/automations-context'

export function AutomationsPrimaryButtons() {
  const { setOpen } = useAutomations()
  const queryClient = useQueryClient()
  const { filters } = useFilters('/_authenticated/automations/')

  const handleUpdateAutomations = async () => {
    await queryClient.invalidateQueries(listAutomationsQuery(filters))
    toast.success('Automações atualizadas')
  }

  return (
    <div className='flex gap-2'>
      <Button
        variant='outline'
        className='space-x-1'
        onClick={handleUpdateAutomations}
      >
        <span>Atualizar</span> <IconRefresh size={18} />
      </Button>
      <Button className='space-x-1' onClick={() => setOpen('create')}>
        <span>Nova Automação</span> <IconPlus size={18} />
      </Button>
    </div>
  )
}
